export default "__VITE_ASSET__BnIzJgKu__"